import React from 'react';

import CalculatorCore, {Props} from './CalculatorCore';

export default class CalculatorWACE extends React.Component<Props> {
  render() {
    return <CalculatorCore {...this.props} showRaw={false} />;
  }
}
